
import { defineComponent } from 'vue'
import { store } from '../shared/store.js'

export default defineComponent({
name: 'WardCard',
props: ['title', 'patient'],
data () {
  return {
    store
  }
}
})
